import React, { useRef, useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import CircleMenuButton from "./CircleMenuButton";
import AboutUs from "./AboutUs";
import General from "./General";
import Sharpshooter from "./Sharpshooter";
import Berserker from "./Berserker";
import Demolitions from "./Demolitions";
import Commando from "./Commando";
import Support from "./Support";
import Firebug from "./Firebug";
import FieldMedic from "./FieldMedic";
import Rules from "./Rules";

export default function Info() {
  const navigate = useNavigate();
  const location = useLocation();
  const currentButton = useRef();
  const [textContent, setTextContent] = useState(AboutUs);
  const [textKey, setTextKey] = useState(1);

  const goToMain = () => {
    navigate("/");
  };

  useEffect(() => {
    const firstButton = document.getElementById("aboutus");
    if (firstButton) {
      firstButton.className = "circle-button selected";
      currentButton.current = firstButton;
      window.location.hash = "#aboutus";
    }
  }, []);

  useEffect(() => {
    const hash = location.hash.replace("#", "");
    setInfo(hash);
  }, [location]);

  const setInfo = (label) => {
    label = label.toString().toLowerCase();
    label = label.replace(" ", "");
    const button = document.getElementById(label);
    if (button) {
      if (currentButton && currentButton.current) {
        currentButton.current.className = "circle-button";
      }
      button.className = "circle-button selected";
      currentButton.current = button;
    }

    switch (label) {
      case "aboutus":
        setTextContent(AboutUs);
        setTextKey(1);
        window.location.hash = "#" + label;
        break;
      case "rules":
        setTextContent(Rules);
        setTextKey(2);
        window.location.hash = "#" + label;
        break;
      case "general":
        setTextContent(General);
        setTextKey(3);
        window.location.hash = "#" + label;
        break;
      case "sharpshooter":
        setTextContent(Sharpshooter);
        setTextKey(4);
        window.location.hash = "#" + label;
        break;
      case "berserker":
        setTextContent(Berserker);
        setTextKey(5);
        window.location.hash = "#" + label;
        break;
      case "demolitions":
        setTextContent(Demolitions);
        setTextKey(6);
        window.location.hash = "#" + label;
        break;
      case "commando":
        setTextContent(Commando);
        setTextKey(7);
        window.location.hash = "#" + label;
        break;
      case "support":
        setTextContent(Support);
        setTextKey(8);
        window.location.hash = "#" + label;
        break;
      case "firebug":
        setTextContent(Firebug);
        setTextKey(9);
        window.location.hash = "#" + label;
        break;
      case "medic":
        setTextContent(FieldMedic);
        setTextKey(10);
        window.location.hash = "#" + label;
        break;
    }
  };

  return (
    <>
      <div className="root">
        <div className="logoContainer" onClick={() => goToMain()}>
          <div className="logoSmaller">
            <b>kfOne</b>
          </div>
          <div className="underLogoSmaller">
            <b>Killing Floor 1 Server</b>
          </div>
        </div>

        <div className="shopMenu">
          <div className="titleText">
            <b>Information panel</b>
          </div>
          <div className="helpDescription">
            <b>Here you can find all the relevant information</b>
          </div>

          <div className="circleMenuContainer">
            <CircleMenuButton
              id="aboutus"
              label={"About us"}
              onClick={setInfo}
            ></CircleMenuButton>
            <CircleMenuButton
              id="rules"
              label={"Rules"}
              onClick={setInfo}
            ></CircleMenuButton>
            <CircleMenuButton
              id="general"
              label={"General"}
              onClick={setInfo}
            ></CircleMenuButton>
            <CircleMenuButton
              id="sharpshooter"
              label={"Sharpshooter"}
              onClick={setInfo}
              icon={true}
            ></CircleMenuButton>
            <CircleMenuButton
              id="berserker"
              label={"Berserker"}
              onClick={setInfo}
              icon={true}
            ></CircleMenuButton>
            <CircleMenuButton
              id="demolitions"
              label={"Demolitions"}
              onClick={setInfo}
              icon={true}
            ></CircleMenuButton>
            <CircleMenuButton
              id="commando"
              label={"Commando"}
              onClick={setInfo}
              icon={true}
            ></CircleMenuButton>
            <CircleMenuButton
              id="support"
              label={"Support"}
              onClick={setInfo}
              icon={true}
            ></CircleMenuButton>
            <CircleMenuButton
              id="firebug"
              label={"Firebug"}
              onClick={setInfo}
              icon={true}
            ></CircleMenuButton>
            <CircleMenuButton
              id="medic"
              label={"Medic"}
              onClick={setInfo}
              icon={true}
            ></CircleMenuButton>
          </div>

          <div className="infoMenu" key={textKey}>
            {textContent}
            <footer>
              <p>© {new Date().getFullYear()}</p>
            </footer>
          </div>
        </div>
      </div>
    </>
  );
}
